import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { DynamicComponentContainer } from './dynamic-container.component';
import { ContainerComponentsModule } from '../containers.module';
import { PresentationalComponentsModule } from '../../components/components.module'

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        ContainerComponentsModule,
        PresentationalComponentsModule
    ],
    declarations: [
        DynamicComponentContainer
    ],
    exports: [
        DynamicComponentContainer
    ]
})
export class DynamicComponentModule {

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/notfound-container/dynamic.component.module.ts